export default {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  user: state => state.user.user,
  userInfo: state => state.user.userInfo,
  token: state => state.user.token,
  roles: state => state.user.roles,
  microAppRoutes: state => state.user.microAppRoutes,
  company: state => state.user.company
};
